export const isElectron = () => global.window && global.window._CursiveRecorder !== undefined;

export const CursiveRecorder = () => global.window && global.window._CursiveRecorder;

export const recordingDetails = async () => {
  if (CursiveRecorder().getFullRecorderDetails) {
    return await CursiveRecorder().getFullRecorderDetails();
  }
  return await CursiveRecorder().getRecorderDetails();
};
